import { createStore } from 'effector';
import { AnalyticsMixingData } from '@@/mixing/ts/analytic.types';
import { createEffect, createEvent, sample } from '@lib/state-engine';
// import {
//   fetchFillWarehouseBagFx,
//   fillWarehouseBagSuccess,
// } from '@entities/warehouse/store';
// import { IBagApi, IFillWarehouseBagData } from '@@/bags/ts';
// import { IBagsService } from '@@/bags/services/bags.service';
// import { responseErrorInterceptorNotification } from '@@/common/utils/response-error-interceptor-notification.util';
import { DiContainer } from '@@/di/di-container';
import { AnalyticsMixingService } from '@@/mixing/services/analytics-mixing.service';
import persist from 'effector-localstorage';

const setAnalyticDataLoadingStatus = createEvent<{
  loading: boolean;
  error: boolean | Error;
}>();
export const updateAnalyticData = createEvent<AnalyticsMixingData>();

export const fetchAnalyticsDataPeriod = createEvent<{
  period: number;
}>('fetchAnalyticsData');

export const $analyticDataLoading = createStore<{
  loading: boolean;
  error: boolean | Error;
}>({
  loading: false,
  error: false,
}).on(setAnalyticDataLoadingStatus, (_s, payload) => {
  return payload;
});

export const $analyticData = createStore<AnalyticsMixingData | null>(null).on(
  updateAnalyticData,
  (_, newData) => newData,
);

const analyticsMixingService = DiContainer.get(AnalyticsMixingService);

// Создаем store для хранения состояния серий
export interface SeriesState {
  series: Array<{
    name: string;
    disabled: boolean;
  }>;
}

export const $seriesState = createStore<SeriesState>({
  series: [
    { name: 'Стоимость с миксованием', disabled: false },
    { name: 'Стоимость без миксования', disabled: false },
    { name: 'Стоимость складов с учетом логистики (НЕТТО)', disabled: false },
  ],
});

// Создаем событие для обновления состояния серии
export const updateSeriesState = createEvent<{
  seriesName: string;
  disabled: boolean;
}>('');

// Обновляем store при изменении состояния серии
$seriesState.on(updateSeriesState, (state, { seriesName, disabled }) => ({
  ...state,
  series: state.series.map((series) =>
    series.name === seriesName ? { ...series, disabled } : series,
  ),
}));

// Сохраняем состояние в localStorage с правильной типизацией
persist({
  store: $seriesState,
  key: 'analyticsSeriesState',
});

// Создаем store для хранения последнего периода
const $lastPeriod = createStore<number | null>(null);
// Создаем событие для обновления значения
const updateLastPeriod = createEvent<number>();

// Обновляем store через событие
$lastPeriod.on(updateLastPeriod, (_, period) => period);
// Сохраняем состояние в localStorage
persist({
  store: $lastPeriod,
  key: 'analyticsLastPeriod',
});

// Создаем store для хранения количества дней
export const $datesLength = createStore<number | null>(null);
// Создаем событие для обновления значения
export const updateDateLength = createEvent<number>();

// Обновляем store через событие
$datesLength.on(updateDateLength, (_, length) => length);
// Сохраняем состояние в localStorage
persist({
  store: $datesLength,
  key: 'analyticsDatesLength',
});

// Определяем интерфейс для периода
interface PeriodRange {
  min: number;
  max: number;
}

// Создаем store для хранения диапазона периодов
export const $lastPeriodSelection = createStore<PeriodRange | null>(null);

// Создаем событие для обновления значения периода
export const updateLastPeriodSelection = createEvent<PeriodRange>();

// Обновляем store через событие
$lastPeriodSelection.on(updateLastPeriodSelection, (_, period) => period);

// Сохраняем состояние в localStorage с правильной типизацией
persist({
  store: $lastPeriodSelection,
  key: 'analyticsLastPeriodSelection',
});

export const fetchMixingAnalitycDataChartFx = createEffect(async (period: number) => {
  // Сохраняем новый период в store
  if (period !== undefined) {
    updateLastPeriod(period);
  }

  // Получаем период для запроса
  const requestPeriod = period ?? $lastPeriod.getState();

  const data = await analyticsMixingService.getData(requestPeriod);
  return data;
});
export const fetchMixingAnalitycDataFx = createEffect(async () => {
  const requestPeriod = $lastPeriod.getState() ?? 7;

  let data = await analyticsMixingService.getData(requestPeriod);
  return data;
});

fetchMixingAnalitycDataFx.pending.watch((pending) => {
  pending && setAnalyticDataLoadingStatus({ loading: true, error: false });
  return;
});

fetchMixingAnalitycDataFx.fail.watch(({ error }) => {
  error && setAnalyticDataLoadingStatus({ loading: false, error });
  return;
});

fetchMixingAnalitycDataFx.finally.watch(() => {
  setAnalyticDataLoadingStatus({
    error: $analyticDataLoading.getState().error,
    loading: false,
  });
});

sample({
  clock: fetchMixingAnalitycDataFx.doneData,
  target: updateAnalyticData,
});
sample({
  clock: fetchMixingAnalitycDataChartFx.doneData,
  target: updateAnalyticData,
});
